module.exports = __webpack_public_path__ + "img/264.1f739f6c.jpg";